import {
  Entity,
  type EntityFields,
  type EntityRecord,
  Fields,
} from '@burnsred/entity';

class MockEndpointRefEntity extends Entity {
  static fields: EntityFields<MockEndpointRefEntityFields> = {
    uuid: new Fields.IdField(),
    method: new Fields.CharField({ blank: true, local: true }),
    path_pattern: new Fields.CharField({ blank: true, local: true }),
    name: new Fields.CharField({ blank: true, local: true }),
  };
}

export type MockEndpointRefEntityFields = {
  uuid: string;
  method: string;
  path_pattern: string;
  name: string;
};

export type MockEndpointRefEntityRecord =
  EntityRecord<MockEndpointRefEntityFields>;

export default MockEndpointRefEntity;
